import {
    SET_ASSET_APPROVAL_DATA,
    SET_IS_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL,
    SET_TRANSFER_APPROVAL_REQUEST_OPTION_,
    SET_TRANSFER_APPROVER_ACTIONS_DATA,
    SET_TRANSFER_ORDER_APPROVAL_REQUEST
} from "./TransferApprovalType";

const initialState = {
    isTransferItemAndOrderLevelApprovalData: null,
    transferApproverActionData: [],
    transferOrderApprovalRequest: {
        orderId: 0,
        approverEmailId: '',
        approverActionId: 0,
        comment: '',
        requestApproveVMs: []
    },
    transferApprovalRequestOption: {},
    assetApprovalData: {}
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_IS_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL:
            return {
                ...state,
                isTransferItemAndOrderLevelApprovalData: action.isTransferItemAndOrderLevelApprovalData,
            };
            case SET_ASSET_APPROVAL_DATA:
                return {
                    ...state,
                    assetApprovalData: action.assetApprovalData,
                };
            case SET_TRANSFER_APPROVER_ACTIONS_DATA:
            return {
                ...state,
                transferApproverActionData: action.transferApproverActionData,
            };
            case SET_TRANSFER_ORDER_APPROVAL_REQUEST:
            return {
                ...state,
                transferOrderApprovalRequest: action.transferOrderApprovalRequest,
            };
            case SET_TRANSFER_APPROVAL_REQUEST_OPTION_:
            return {
                ...state,
                transferApprovalRequestOption: action.transferApprovalRequestOption,
            };
        default:
            return state;
    }
};

export default reducer;
